import "./plasticCapabilites.css"
import React, { useState, useCallback, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import logoPlasticParts from "../../imagens/logos/logoPlasticParts.png"

function ImgPlasticos({ listaPecaPlastica }) {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)

    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }


    const prevSlide = useCallback(() => {
        slideNumber === 0 ?
            setSlideNumber(listaPecaPlastica.length - 1) :
            setSlideNumber(slideNumber - 1)
    }, [slideNumber, listaPecaPlastica.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listaPecaPlastica.length ?
            setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)

    }, [slideNumber, listaPecaPlastica.length])
    
    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);


    return (
        <div>
            {
                openModal &&
                <div className='plasticSliderWrap'>
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="plasticBtnPrev" onClick={() => prevSlide()} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="plasticBtnNext" onClick={() => nextSlide()} />
                    <FontAwesomeIcon icon={faCircleXmark} className="plasticBtnClose" onClick={() => handleCloseModal()} />
                    <img className='plasticFullScreenImage' src={listaPecaPlastica[slideNumber].img} alt='plasticImg' />
                </div>
            }
            <div>
                <img className='img-custom-size img-fluid ms-2' src={logoPlasticParts} alt='logoplastics' />
            </div>
            <div className="plasticGalleryWrap mx-2">
                {
                    listaPecaPlastica && listaPecaPlastica.map((image, index) => {
                        return (
                            <div
                                className="plasticSingle"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <img src={image.img} alt="plastics"/>

                            </div>
                        )
                    })
                }
            </div>
            <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities/Production">
                    <button className="buttonCapabilities">Back to Production Capabilities</button>
                </Link>
            </div>


        </div>
    )
}

export default ImgPlasticos